import {API_URL} from "../../constants";
import {makeRequest} from "../../services/requestService";
import React from "react";
import {Autocomplete, debounce, MenuItem, TextField} from "@mui/material";
import PropTypes from "prop-types";
import {useTranslation} from "react-i18next";

const MIN_LENGTH_BEFORE_QUERY = 1;

async function findUsers(username) {
    if (!username) return [];
    const url = `${API_URL}/users/search?page=0&size=10&username=${username}`;
    const response = await makeRequest(url);
    return response.data.data;
}

export default function SearchUser(props) {
    const {t} = useTranslation('common');
    const [value, setValue] = React.useState(null);
    const [inputValue, setInputValue] = React.useState('');
    const [options, setOptions] = React.useState([]);

    React.useEffect(async () => {
        if (inputValue.length < MIN_LENGTH_BEFORE_QUERY) {
            setOptions(value ? [value] : []);
            return;
        }

        const options = await findUsers(inputValue);
        setOptions(options);
    }, [value, inputValue]);

    function handleChange(_, newValue) {
        console.log("newValue", newValue);
        setValue(newValue);
        props.onChange(newValue);
    }

    return (
        <Autocomplete
            {...props}
            sx={{width: 300}}
            getOptionLabel={(option) =>
                typeof option === 'string' ? option : option.name
            }
            options={options}
            autoComplete
            filterSelectedOptions
            noOptionsText={inputValue.length < MIN_LENGTH_BEFORE_QUERY ?
                t("main.components.search.user.empty") :
                t("main.components.search.user.nousers")
            }
            value={value}
            onChange={handleChange}
            // isOptionEqualToValue={(option, value) => option.id === value.id}
            onInputChange={(event, newInputValue) => {
                setInputValue(newInputValue);
            }}
            renderInput={(params) => (
                <TextField {...params} label={t("main.components.search.user.label")} fullWidth/>
            )}
            renderOption={(props, option) => {
                return (
                    <MenuItem {...props} value={option.id}>{option.name}</MenuItem>
                );
            }}
        />
    );
}

SearchUser.propTypes = {
    onChange: PropTypes.func.isRequired,
}